'use client';

/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Header } from '@kbbsdk/global-sdk/navigation/web';
import FallbackProxy from '@kbbsdk/global-sdk/analytics/FallbackProxy';
import { isFlipperOn } from '../utilities/flipperUtils';

export const AnalyticsContext = React.createContext();

function HeaderContainer({ navigation }) {
  const [kbbCognitoFlipper, setKbbCognitoFlipper] = useState(false);
  const flipperName = 'mykbb-cognito';
  const suppressZipCode = true;
  const withoutLilGuy = true;
  let cognitoExperience = false;
  const useWebComponent = true;
  const ignoreWebComponentJS = true;

  useEffect(() => {
    const getFlipperStatus = async () => {
      const isKbbFlipperOn = await isFlipperOn(flipperName);
      setKbbCognitoFlipper(isKbbFlipperOn);
    };
    getFlipperStatus();
  }, []);

  if (kbbCognitoFlipper) {
    cognitoExperience = true;
  }

  return (
    <AnalyticsContext.Provider value={FallbackProxy}>
      <Header
        navigation={navigation}
        withMyKbb={withoutLilGuy}
        suppressZipCode={suppressZipCode}
        enableCognitoExperience={cognitoExperience}
        useWebComponent={useWebComponent}
        ignoreWebComponentJS={ignoreWebComponentJS}
      />
    </AnalyticsContext.Provider>
  );
}

export default HeaderContainer;
